"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { useClerk } from "@clerk/nextjs";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface SignInGateModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SignInGateModal({ open, onOpenChange }: SignInGateModalProps) {
  const { openSignIn, openSignUp } = useClerk();

  useEffect(() => {
    if (open) {
      posthog.capture("sign_in_gate_shown", { trigger: "free_conversion_used" });
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange} modal={false}>
      {open && (
        <div
          className="fixed inset-0 z-40 bg-black/80 animate-in fade-in-0"
          aria-hidden
        />
      )}
      <DialogContent
        className="sm:max-w-md"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Lock className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle className="text-center">
            Unlock unlimited conversions and repairs
          </DialogTitle>
          <DialogDescription className="text-center">
            Create a free account to convert and repair as many files as you
            want, no limits.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <Button className="w-full" onClick={() => openSignUp()}>
            Sign up free
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => openSignIn()}
          >
            Sign in
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
